<template>
  <div class="operation-logs">
    <div class="filter-bar">
      <select v-model="filters.operator_type" class="filter-select">
        <option value="">全部操作者</option>
        <option value="1">管理员</option>
        <option value="2">用户</option>
      </select>
      <input
        v-model="filters.operator_id"
        class="filter-input"
        placeholder="操作者ID"
        @keyup.enter="loadLogs"
      />
      <input
        v-model="filters.module"
        class="filter-input"
        placeholder="模块"
        @keyup.enter="loadLogs"
      />
      <input
        v-model="filters.action"
        class="filter-input"
        placeholder="动作"
        @keyup.enter="loadLogs"
      />
      <input
        v-model="filters.client_ip"
        class="filter-input"
        placeholder="客户端IP"
        @keyup.enter="loadLogs"
      />
      <input v-model="filters.start_at" type="date" class="filter-input" placeholder="开始日期" />
      <input v-model="filters.end_at" type="date" class="filter-input" placeholder="结束日期" />
      <button class="btn btn-primary" @click="loadLogs">查询</button>
      <button class="btn btn-default" @click="resetFilters">重置</button>
    </div>

    <table class="data-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>操作者</th>
          <th>模块</th>
          <th>动作</th>
          <th>描述</th>
          <th>请求</th>
          <th>IP</th>
          <th>操作时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ operatorText(item) }}</td>
          <td>{{ item.module || '-' }}</td>
          <td>{{ item.action || '-' }}</td>
          <td class="desc-cell" :title="item.description">{{ item.description || '-' }}</td>
          <td class="req-cell" :title="requestText(item)">{{ requestText(item) }}</td>
          <td>{{ item.client_ip || '-' }}</td>
          <td>{{ formatDateTime(item.created_at) }}</td>
          <td>
            <button class="action-btn view" @click="openDetail(item)">详情</button>
          </td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="9" class="empty">暂无数据</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination" v-if="total > 0">
      <button class="page-btn" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页（共 {{ total }} 条）</span>
      <button class="page-btn" :disabled="currentPage >= totalPages" @click="changePage(currentPage + 1)">下一页</button>
    </div>

    <div v-if="detailVisible" class="modal-mask" @click.self="detailVisible = false">
      <div class="modal-box">
        <div class="modal-header">
          <span>操作日志详情 #{{ detail.id }}</span>
          <button class="modal-close" @click="detailVisible = false">×</button>
        </div>
        <div class="modal-body">
          <div class="detail-row"><span class="detail-label">操作者</span><span>{{ operatorText(detail) }}</span></div>
          <div class="detail-row"><span class="detail-label">模块</span><span>{{ detail.module || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">动作</span><span>{{ detail.action || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">描述</span><span>{{ detail.description || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">请求方式</span><span>{{ detail.request_method || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">请求地址</span><span class="break-all">{{ detail.request_url || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">响应码</span><span>{{ detail.response_code !== null && detail.response_code !== undefined ? detail.response_code : '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">客户端IP</span><span>{{ detail.client_ip || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">操作时间</span><span>{{ formatDateTime(detail.created_at) }}</span></div>
          <div class="detail-row detail-block">
            <span class="detail-label">请求参数</span>
            <pre class="detail-params">{{ formatParams(detail.request_params) }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOperationLogs } from '@/api/system'

export default {
  name: 'OperationLogs',
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      perPage: 15,
      filters: {
        operator_type: '',
        operator_id: '',
        module: '',
        action: '',
        client_ip: '',
        start_at: '',
        end_at: ''
      },
      loading: false,
      detailVisible: false,
      detail: {}
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.perPage))
    }
  },
  mounted() {
    this.loadLogs()
  },
  methods: {
    async loadLogs() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.perPage,
          operator_type: this.filters.operator_type !== '' ? this.filters.operator_type : undefined,
          operator_id: this.filters.operator_id ? Number(this.filters.operator_id) : undefined,
          module: this.filters.module || undefined,
          action: this.filters.action || undefined,
          client_ip: this.filters.client_ip || undefined,
          start_at: this.filters.start_at || undefined,
          end_at: this.filters.end_at || undefined
        }
        const res = await getOperationLogs(params)
        // OperationLogController 返回 data: { list, total, current_page, ... }
        const payload = (res && res.data) || {}
        this.list = payload.list || []
        this.total = payload.total || 0
        if (payload.current_page) this.currentPage = payload.current_page
      } catch (e) {
        this.$message && this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    operatorText(item) {
      const type = item.operator_type === 1 ? '管理员' : item.operator_type === 2 ? '用户' : '未知'
      return `${type} #${item.operator_id || '-'}`
    },
    requestText(item) {
      if (!item.request_method && !item.request_url) return '-'
      return `${item.request_method || ''} ${item.request_url || ''}`.trim()
    },
    formatDateTime(value) {
      if (!value) return '-'
      const d = new Date(value)
      if (isNaN(d.getTime())) return value
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    formatParams(value) {
      if (value === null || value === undefined || value === '') return '-'
      if (typeof value === 'string') {
        try {
          return JSON.stringify(JSON.parse(value), null, 2)
        } catch (e) {
          return value
        }
      }
      try {
        return JSON.stringify(value, null, 2)
      } catch (e) {
        return String(value)
      }
    },
    resetFilters() {
      this.filters = {
        operator_type: '',
        operator_id: '',
        module: '',
        action: '',
        client_ip: '',
        start_at: '',
        end_at: ''
      }
      this.currentPage = 1
      this.loadLogs()
    },
    changePage(page) {
      this.currentPage = page
      this.loadLogs()
    },
    openDetail(item) {
      this.detail = item
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  align-items: center;
}
.filter-input,
.filter-select {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.data-table th,
.data-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
}
.data-table th {
  background: #fafafa;
  font-weight: 600;
}
.data-table tr:hover td {
  background: #f9faff;
}
.desc-cell,
.req-cell {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.empty {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.btn-primary {
  background: #667eea;
  color: #fff;
}
.btn-default {
  background: #eee;
  color: #333;
}
.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}
.action-btn.view {
  background: #3498db;
  color: #fff;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 16px;
}
.page-btn {
  padding: 6px 14px;
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.page-info {
  font-size: 14px;
  color: #666;
}
.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-box {
  width: 560px;
  max-width: 92vw;
  max-height: 84vh;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  font-weight: 600;
}
.modal-close {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #999;
}
.modal-body {
  padding: 16px 18px;
  overflow-y: auto;
}
.detail-row {
  display: flex;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px dashed #f0f0f0;
  font-size: 14px;
}
.detail-label {
  width: 90px;
  flex-shrink: 0;
  color: #888;
}
.detail-block {
  flex-direction: column;
}
.break-all {
  word-break: break-all;
}
.detail-params {
  margin: 6px 0 0;
  padding: 10px;
  background: #f7f8fa;
  border-radius: 4px;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 240px;
  overflow: auto;
}
</style>
